import React from "react";
import { Fade } from "react-awesome-reveal";
import Header from "parts/Header";
import Discuss from "parts/Discuss";
import Footer from "parts/Footer";

export default function AboutUs() {
  return (
    <>
      <Header />

      <section className="text-gray-800 py-16 px-4 md:px-10">
        {/* Title */}
        <div className="text-center mb-16">
          <Fade direction="up" triggerOnce>
            <h1 className="text-5xl font-extrabold text-green-800 mb-6 text-shadow-xl transform transition-all duration-500 ease-in-out">
              About Us
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed opacity-80">
              We are committed to delivering excellence through innovation,
              collaboration, and integrity.
            </p>
          </Fade>
        </div>

        {/* Backgrounds Card Full Width */}
        <div className="mb-20">
          <Fade direction="left" triggerOnce>
            <div className="bg-white border-2 border-green-500 rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 w-full mx-auto">
              <h2 className="text-3xl font-extrabold text-green-800 mb-4 text-shadow-md">
                Backgrounds
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                AT Landscape PLC was incorporated under the laws of Ethiopia in
                October 2010. Initially named A.T General Designing and
                Landscaping Service, the company grew and was upgraded to PLC in
                2020 with a capital of 200,000.00 Birr. Initially focused on
                Landscaping, we now also engage in large-scale flower farming.
                Marine Logistics Pie is a sister company, focused on transport
                and transit services. AT employs 70 contractors and 10 permanent
                staff.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Our expertise has grown over the years, building a team of
                skilled landscape professionals. AT provides superior quality,
                customized landscape designs, establishment, and maintenance
                services. While small enough to offer personalized attention, we
                are large enough to exceed our clients' expectations.
              </p>
            </div>
          </Fade>
        </div>

        {/* Vision, Mission, Values, Services */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-12">
          {/* Vision */}
          <Fade direction="left" triggerOnce>
            <div className="bg-white border-2 border-green-500 rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8">
              <h2 className="text-2xl font-extrabold text-green-700 mb-4 transform transition-all duration-500 hover:text-green-900">
                Our Vision
              </h2>
              <p className="text-gray-700 leading-relaxed">
                To be the leading landscaping service provider in Ethiopia.
              </p>
            </div>
          </Fade>

          {/* Mission */}
          <Fade direction="up" triggerOnce>
            <div className="bg-white border-2 border-green-500 rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8">
              <h2 className="text-2xl font-extrabold text-green-700 mb-4 transform transition-all duration-500 hover:text-green-900">
                Our Mission
              </h2>
              <p className="text-gray-700 leading-relaxed">
                AT Landscape strives to be competitive globally by consistently
                delivering sustainable, high-quality service with reliability,
                promptness, and first-class customer service.
              </p>
            </div>
          </Fade>

          {/* Principles and Values */}
          <Fade direction="up" triggerOnce>
            <div className="bg-white border-2 border-green-500 rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8">
              <h2 className="text-2xl font-extrabold text-green-700 mb-4 transform transition-all duration-500 hover:text-green-900">
                Our Principles and Values
              </h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Reliability</li>
                <li>Efficiency</li>
                <li>Productivity and Professionalism</li>
                <li>Readiness to Learn and Excel</li>
              </ul>
            </div>
          </Fade>

          {/* Services */}
          <Fade direction="right" triggerOnce>
            <div className="bg-white border-2 border-green-500 rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8">
              <h2 className="text-2xl font-extrabold text-green-700 mb-4 transform transition-all duration-500 hover:text-green-900">
                Services We Provide
              </h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Garden Design and Development</li>
                <li>Supply of Seedlings, Red Ash, Organic Manure</li>
                <li>Supply of Natural Flowers</li>
                <li>Park Development, Football Field Development</li>
                <li>
                  Beautifying Compounds, Hotels, Residential Houses, Offices,
                  etc.
                </li>
                <li>Care and Maintenance of Established Gardens</li>
                <li>Fountain Design and Development</li>
              </ul>
            </div>
          </Fade>
        </div>
      </section>

      <Discuss />
      <Footer />
    </>
  );
}
